(function () {
  const cfg = window.RelloFreeGift;
  if (!cfg?.enabled || !cfg.variantId || !(cfg.threshold > 0) || window.RelloGiftController) return;
  const source = 'rello-free-gift';
  const nativeFetch = window.fetch.bind(window);
  const writes = new Set();
  let running = null;
  let timer;
  let revision = 0;
  let checkoutPending = false;
  const gifts = Array.isArray(cfg.gifts) && cfg.gifts.length ? cfg.gifts : [{ variantId: cfg.variantId, productId: cfg.productId, key: 'gift' }];
  const giftVariantIds = new Set(gifts.map(g => String(g.variantId)));
  const isGift = (item) => giftVariantIds.has(String(item.variant_id)) || !!(item.properties && item.properties._rello_free_gift);
  const STORAGE_KEY = 'rello_gift_pick';
  const flavorOf = (g) => /vanilla/i.test(g.key) ? 'vanilla' : /choc/i.test(g.key) ? 'chocolate' : null;
  function persistedPick() {
    try { const v = localStorage.getItem(STORAGE_KEY); return v && giftVariantIds.has(v) ? v : null; } catch (_) { return null; }
  }
  function remember(variantId) { try { localStorage.setItem(STORAGE_KEY, String(variantId)); } catch (_) {} }
  function randomGift() {
    const kept = persistedPick();
    if (kept) return gifts.find(g => String(g.variantId) === kept);
    const pick = gifts[Math.floor(Math.random() * gifts.length)];
    remember(pick.variantId);
    return pick;
  }
  // Decide which gift to add for this cart.
  function chooseGift(cart) {
    if (gifts.length === 1 || cfg.mode === 'first' || !cfg.mode) return gifts[0];
    if (cfg.mode === 'opposite') {
      const inCart = new Set();
      cart.items.forEach(item => {
        if (isGift(item)) return;
        const f = (cfg.flavorProducts || {})[String(item.product_id)];
        if (f) inCart.add(f);
      });
      if (inCart.size === 1) {
        const bought = [...inCart][0];
        const opposite = gifts.find(g => flavorOf(g) && flavorOf(g) !== bought);
        if (opposite) { remember(opposite.variantId); return opposite; }
      }
    }
    return randomGift();
  }
  const endpoint = (path) => path.endsWith('.js') ? path : path + '.js';

  async function request(url, body) {
    const response = await nativeFetch(url, {
      method: body ? 'POST' : 'GET', cache: 'no-store', credentials: 'same-origin',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.errors || data.status >= 400) throw new Error(data.description || data.message || 'Unable to update cart');
    return data;
  }

  async function sections() {
    const ids = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
    if (!ids.length) return {};
    const url = new URL(window.location.href);
    url.searchParams.delete('section_id');
    url.searchParams.set('sections', ids.join(','));
    return request(url.toString());
  }

  async function settle() {
    for (let attempt = 0; attempt < 10; attempt++) {
      await Promise.allSettled([...writes]);
      const observedRevision = revision;
      const cart = await request(endpoint(cfg.routes.cart));
      if (observedRevision !== revision || writes.size) continue;
      const gifts = cart.items.filter(isGift);
      const paid = cart.total_price - gifts.reduce((sum, item) => sum + item.final_line_price, 0);
      const eligible = paid >= cfg.threshold;
      if (eligible && !gifts.length) {
        const gift = chooseGift(cart);
        await request(endpoint(cfg.routes.add), { items: [{ id: gift.variantId, quantity: 1, properties: { _rello_free_gift: 'true' } }] });
        continue;
      }
      const updates = {};
      gifts.forEach((item, index) => {
        const quantity = eligible && index === 0 ? 1 : 0;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      });
      if (Object.keys(updates).length) {
        await request(endpoint(cfg.routes.update), { updates });
        continue;
      }
      if (eligible && gifts.some(item => item.final_line_price !== 0)) {
        throw new Error('Mystery Gift discount did not apply');
      }
      cart.sections = await sections();
      if (observedRevision !== revision || writes.size) continue;
      return cart;
    }
    throw new Error('Cart is still changing. Please try again.');
  }

  function sync(options = {}) {
    clearTimeout(timer);
    if (!running) {
      const operation = () => settle();
      running = (window.navigator?.locks ? window.navigator.locks.request('rello-free-gift-cart', operation) : operation())
        .finally(() => { running = null; });
    }
    return running.then(cart => {
      if (options.notify !== false) document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true, detail: { resource: cart, sourceId: source, data: { source, itemCount: cart.item_count, sections: cart.sections } }
      }));
      return cart;
    });
  }

  function schedule(event) {
    if (event?.detail?.data?.source === source || checkoutPending) return;
    clearTimeout(timer);
    timer = setTimeout(() => sync().catch(error => console.warn('[Rello gift]', error)), 100);
  }
  window.RelloGiftController = { sync };

  window.fetch = function (input, init) {
    let mutation = false;
    try {
      const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href);
      const method = (init?.method || input?.method || 'GET').toUpperCase();
      mutation = url.origin === window.location.origin && method === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
    } catch (_) {}
    const operation = nativeFetch(input, init);
    if (mutation) {
      writes.add(operation);
      operation.then(response => { if (response.ok) revision++; }, () => {}).finally(() => { writes.delete(operation); schedule(); });
    }
    return operation;
  };

  for (const name of ['cart:update', 'discount:update', 'cart:updated', 'cart:refresh', 'shopify:cart:lines-update']) document.addEventListener(name, schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);

  async function checkout(event) {
    const trigger = event.type === 'click' ? event.target.closest?.('[name="checkout"], a[href]') : event.submitter;
    const checkoutLink = trigger?.tagName === 'A' && /^\/checkout\/?$/.test(new URL(trigger.href, window.location.href).pathname);
    const checkoutButton = trigger?.name === 'checkout';
    if (!checkoutButton && !checkoutLink) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    trigger.setAttribute('aria-busy', 'true');
    try {
      await sync();
      window.location.assign(checkoutLink ? trigger.href : cfg.routes.checkout);
    } catch (error) {
      checkoutPending = false;
      trigger.removeAttribute('aria-busy');
      window.alert(cfg.errorMessage);
      console.warn('[Rello gift]', error);
    }
  }
  document.addEventListener('click', checkout, true);
  document.addEventListener('submit', checkout, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();
